import React, {useState} from 'react'
import { Tooltip } from '@cleartrip/bento/components/Tooltip'
import { returnFareName } from 'constants/fareType'

function TooltipMessage(props) {
    const {title = '', sft, width = '244px', height = '20px', distance = 10, right = '20px'} = props
    const [showToolTip,setShowToolTip] = useState(false)
    return (
        <div
            onMouseLeave={() => setShowToolTip(false)}
            onMouseOver={() => setShowToolTip(true)}
            className="flex flex-end p-absolute"
            style={{ height: height, width: width, backgroundColor: '#ffffff00'}}
        >
            {showToolTip ? (
                <div className="p-absolute" style={{right: right, top: '20px' }}>
                    <Tooltip
                        arrow
                        open={true}
                        position="bottom-end"
                        offset="-40px"
                        distance={distance}
                        width={216}
                        content={<p className="fs-2">You cannot add {title.toLowerCase()} to {returnFareName(sft).toLocaleLowerCase()}</p>}
                    ></Tooltip>
                </div>
            ) : null}
        </div>
    )
}

export default TooltipMessage
